import { formatTo12Hour } from 'utils/dateTimeUtils/dateFormatUtil';

import { HorizontalContainer } from '@american-autonomy/ag-ui';

import CardLink from 'components/text/CardLink';
import LabelText from 'components/text/LabelText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ActivityCardItem: FunctionComponent<Props> = ({
    className = '',
    date,
    detailsUrl,
    testId = TEST_ID,
    text = ''
}) => {
    const formattedHour = formatTo12Hour(date);

    return (
        <HorizontalContainer className={`${className} ${styles.activityCardItem}`} testId={testId}>
            <LabelText className={styles.labelText} text={`${formattedHour}`} />

            <CardLink text={text} to={detailsUrl} />
        </HorizontalContainer>
    );
};

export default ActivityCardItem;
